// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c02a701","239":"e0aca953","455":"89c3a5c3"}[chunkId] + ".chunk.js";
};